import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: undefined,
  status: 'idle',
};


export const tokenInfoSlice = createSlice({
  name: 'tokenInfo',
  initialState,
  reducers: {
    updateTokenInfo: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { updateTokenInfo } = tokenInfoSlice.actions;

export const tokenInfo = (state) => state.tokenInfo.value;

export default tokenInfoSlice.reducer;
